var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.params.value)?_c('div',{staticClass:"flex items-center"},[_c('router-link',{staticClass:"text-inherit hover:text-primary",attrs:{"to":_vm.url},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();}}},[_vm._v(_vm._s(_vm.jenis.find(j => j.id == _vm.params.value).name))])],1):_c('span',[_vm._v("-")])])
}
var staticRenderFns = []

export { render, staticRenderFns }